(function () {
  if (window.__multilikesProductFavWired) {
    if (typeof window.__multilikesProductFavInit === 'function') {
      window.__multilikesProductFavInit();
    }
    return;
  }
  window.__multilikesProductFavWired = true;

  var cfg = window.__multilikesFavConfig || {};
  var apiBase = cfg.apiBase || '/apps/multilikes-endpoint';
  var isLoggedIn = !!cfg.isLoggedIn;
  var customerId = cfg.customerId || null;
  var loginUrl = cfg.loginUrl || '/account/login';

  function setState(btn, favorited) {
    btn.classList.toggle('is-favorited', favorited);
    btn.setAttribute('aria-pressed', String(favorited));
    var label = btn.querySelector('.multilikes-favorite__label');
    var textOn = btn.dataset.labelOn || 'お気に入り登録済み';
    var textOff = btn.dataset.labelOff || 'お気に入り登録';
    var nextText = favorited ? textOn : textOff;
    if (label) label.textContent = nextText;
    btn.setAttribute('aria-label', nextText);
  }

  // SP/PC で同じ商品のボタンが複数ある場合、すべてに状態を反映する
  function setStateForProduct(productId, variantId, favorited) {
    var selector = '[data-multilikes-product-favorite]'
      + '[data-product-id="' + productId + '"]'
      + '[data-variant-id="' + variantId + '"]';
    document.querySelectorAll(selector).forEach(function (b) { setState(b, favorited); });
  }

  function fetchState(btn) {
    if (!isLoggedIn) return Promise.resolve(null);
    var params = new URLSearchParams({
      target_type: 'product',
      product_id: btn.dataset.productId,
      variant_id: btn.dataset.variantId,
      customer_id: customerId
    });
    return fetch(apiBase + '?' + params.toString(), {
      method: 'GET',
      credentials: 'include',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (j.error) throw new Error(j.error);
        return !!(j.data && j.data.isInWishlist);
      })
      .catch(function (e) {
        console.error('[Multilikes] お気に入り状態の取得に失敗:', e);
        return null;
      });
  }

  function postToggle(btn, currentlyFavorited) {
    var body = new URLSearchParams({
      target_type: 'product',
      customer_id: customerId,
      action: currentlyFavorited ? 'remove' : 'add',
      product_id: btn.dataset.productId,
      variant_id: btn.dataset.variantId
    });
    return fetch(apiBase, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Accept': 'application/json'
      },
      body: body.toString()
    })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (j.error) throw new Error(j.error);
        return j.data;
      });
  }

  function bind(btn) {
    if (btn.dataset.multilikesFavBound === 'true') return;
    btn.dataset.multilikesFavBound = 'true';

    // 商品 ID・バリアント ID のどちらかが無いボタンは動かさず隠す。
    // 無いまま送ると API に文字列 "undefined" が渡り、お気に入りに壊れた項目が残る
    if (!btn.dataset.productId || !btn.dataset.variantId) {
      console.warn('[Multilikes] product-id / variant-id が無いためお気に入りボタンを無効化:', btn);
      btn.style.display = 'none';
      return;
    }

    if (isLoggedIn) {
      fetchState(btn).then(function (fav) {
        if (fav === null) return;
        setStateForProduct(btn.dataset.productId, btn.dataset.variantId, fav);
      });
    }

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      if (!isLoggedIn) {
        window.location.href = loginUrl;
        return;
      }

      var currently = btn.classList.contains('is-favorited');
      var productId = btn.dataset.productId;
      var variantId = btn.dataset.variantId;

      // 楽観的更新 (連打防止)
      var sameBtns = document.querySelectorAll(
        '[data-multilikes-product-favorite]'
        + '[data-product-id="' + productId + '"]'
        + '[data-variant-id="' + variantId + '"]'
      );
      sameBtns.forEach(function (b) { b.disabled = true; });
      setStateForProduct(productId, variantId, !currently);

      postToggle(btn, currently)
        .then(function (data) {
          setStateForProduct(productId, variantId, !!data.isInWishlist);
          // ヘッダーのお気に入り件数バッジなどへ通知
          document.dispatchEvent(new CustomEvent('multilikes:product-favorite-changed', {
            detail: { favorited: !!data.isInWishlist }
          }));
        })
        .catch(function (err) {
          console.error('[Multilikes] お気に入り更新に失敗:', err);
          setStateForProduct(productId, variantId, currently);
          alert('お気に入りの更新に失敗しました。時間をおいて再度お試しください。');
        })
        .finally(function () {
          sameBtns.forEach(function (b) { b.disabled = false; });
        });
    });
  }

  function init() {
    document.querySelectorAll('[data-multilikes-product-favorite]').forEach(bind);
  }

  window.__multilikesProductFavInit = init;

  // 動的にカードが差し替えられる (タブ切替など) 場合に再バインドできるよう Observer も用意
  if (typeof MutationObserver !== 'undefined') {
    var observer = new MutationObserver(function (mutations) {
      var shouldInit = false;
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length > 0) {
          shouldInit = true;
          break;
        }
      }
      if (shouldInit) init();
    });
    if (document.body) {
      observer.observe(document.body, { childList: true, subtree: true });
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        observer.observe(document.body, { childList: true, subtree: true });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
